import { render } from "./AssignmentTypeCategories.vue?vue&type=template&id=438d97bd"
import script from "./AssignmentTypeCategories.vue?vue&type=script&lang=js"
export * from "./AssignmentTypeCategories.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/eccaplus/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__